import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'login.message.reset.password.bold': {
    id: 'login.message.reset.password.bold',
    defaultMessage: 'you must reset your password',
    description: 'Bold part of the login message informing users to reset their password after January 12',
  },
  'login.message.read.more': {
    id: 'login.message.read.more',
    defaultMessage: 'Read more about why you need to reset your password and the changes at Copernicus College.',
    description: 'Link text inviting users to read more about the password reset requirement at Copernicus College',
  },
});

export default messages;
